export const ADD_GROUP = 'ADD_GROUP';
export const ADD_CASE_GROUP = 'ADD_CASE_GROUP';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const SET_CONJUNCTION = 'SET_CONJUNCTION';
export const SET_NOT = 'SET_NOT';
export const ADD_RULE = 'ADD_RULE';
export const REMOVE_RULE = 'REMOVE_RULE';
export const SET_FIELD = 'SET_FIELD';
export const SET_OPERATOR = 'SET_OPERATOR';
export const SET_VALUE = 'SET_VALUE';
export const SET_VALUE_SRC = 'SET_VALUE_SRC';
export const SET_OPERATOR_OPTION = 'SET_OPERATOR_OPTION';
export const SET_LOCK = 'SET_LOCK';

export const SET_TREE = 'SET_TREE';

export const MOVE_ITEM = 'MOVE_ITEM';

export const PLACEMENT_AFTER = 'after';
export const PLACEMENT_BEFORE = 'before';
export const PLACEMENT_APPEND = 'append';
export const PLACEMENT_PREPEND = 'prepend';

export const SET_DRAG_PROGRESS = 'SET_DRAG_PROGRESS';
export const SET_DRAG_START = 'SET_DRAG_START';
export const SET_DRAG_END = 'SET_DRAG_END';
